import { render, staticRenderFns } from "./phoneAddQuestion.vue?vue&type=template&id=117f8901&scoped=true&"
import script from "./phoneAddQuestion.vue?vue&type=script&lang=js&"
export * from "./phoneAddQuestion.vue?vue&type=script&lang=js&"
import style0 from "./phoneAddQuestion.vue?vue&type=style&index=0&id=117f8901&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "117f8901",
  null
  
)

export default component.exports